module.exports = __webpack_public_path__ + "img/cab0ed2adb4320dceb92f1a1fd561963.png";